export const OBSERVABLE_PRIVATE = Symbol('observable-private');
//# sourceMappingURL=privates.js.map